"use client";

import { useTranslations } from "next-intl";
import { CommandGroup } from "@/components/ui/command";
import { LocationOptionItem } from "../LocationOptionItems";
import type { SuggestedCitiesListProps } from "./types";

export function SuggestedCitiesList({
  options,
  currentArea,
  hasCustomLocation,
  onSelect,
}: SuggestedCitiesListProps) {
  const t = useTranslations();

  const filteredOptions = options.filter(
    (option) => hasCustomLocation || option.value !== currentArea,
  );

  if (filteredOptions.length === 0) {
    return null;
  }

  return (
    <CommandGroup heading={t("locationSelector.suggestedCities")}>
      {filteredOptions.map((option) => (
        <LocationOptionItem
          key={option.value}
          option={option}
          onSelect={() => onSelect(option.value)}
        />
      ))}
    </CommandGroup>
  );
}
